<div
    ngfDrop accept=".xlsx"
    class="mibi-upload"
    [selectable]="1"
    [maxSize]="maxFileSize"
    [fileDropDisabled]="dropDisabled"
    (fileChange)="onFileChange($event)"
    (click)="onUploadInteraction()"
    (dragenter)="onUploadInteraction()"
    [(lastInvalids)]="lastInvalids"
>
    <ng-content></ng-content>
</div>
